var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97363 13.6145C10.6064 13.6145 13.6143 10.6067 13.6143 6.97388C13.6143 3.34757 10.5999 0.333252 6.96712 0.333252C3.34082 0.333252 0.333008 3.34757 0.333008 6.97388C0.333008 10.6067 3.34733 13.6145 6.97363 13.6145ZM6.96712 7.95044C6.62207 7.95044 6.43327 7.74862 6.42025 7.40356L6.3291 4.18742C6.31608 3.82935 6.58952 3.57544 6.96061 3.57544C7.3252 3.57544 7.61165 3.83586 7.59863 4.19393L7.50098 7.40356C7.48796 7.75513 7.29915 7.95044 6.96712 7.95044ZM6.96712 10.3463C6.58952 10.3463 6.23796 10.0468 6.23796 9.64315C6.23796 9.2395 6.58301 8.94002 6.96712 8.94002C7.35124 8.94002 7.69629 9.23299 7.69629 9.64315C7.69629 10.0533 7.34473 10.3463 6.96712 10.3463Z",
    fill: "#FF8F89"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationMark);
export default __webpack_public_path__ + "static/media/icon-exclamation-mark.5f9cd1cc50aa843a70ad152eb230e067.svg";
export { ForwardRef as ReactComponent };